if (window.innerWidth < 551) {
    $('.brand-tab-block .halo-row').slick({
        adaptiveHeight: true,
        vertical: false,
        infinite: false,
        slidesToShow: 3,
        slidesToScroll: 3,
        arrows: true,
        dots: false,
        nextArrow: window.arrows.icon_next,
        prevArrow: window.arrows.icon_prev,
        rtl: window.rtl_slick,
    });
}